import React from 'react';
const LINK_REGEX = /\[.+?\]\(((mailto:)|(https?:\/\/))(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)\)/g;
const BOLD_REGEX = /\*(.*?)\*/g;
const convertToIndex = (acc, a, index) => acc.replace(a, `\n__${index}\n`);
export const formatPhoneNumber = (phoneNumber) => {
    return phoneNumber.replace(/([+].{2}|.{3})(.{3})(.{3})/, '$1 $2 $3 ').trim();
};
export function formatColor(msg = '') {
    const match = msg.match(/<color=#.{6}>(.*?)<\/color>/g);
    if (match) {
        return match
            .reduce(convertToIndex, msg)
            .split('\n')
            .map((item, key) => {
            if (item.match(/__\d/)) {
                const textWithTags = match[parseInt(item.replace('__', ''), 10)];
                const text = textWithTags.replace(/<(.|\n)*?>/g, '');
                const color = textWithTags.match(/#.{6}/g)[0];
                return (React.createElement("span", { key: key, style: { color } }, text));
            }
            return React.createElement("span", { key: key }, item);
        });
    }
    return React.createElement("span", null, msg);
}
export function textWithBold(text, regex = BOLD_REGEX, replace = /\*/g) {
    const match = text.match(regex) || [];
    return match
        .reduce(convertToIndex, text)
        .split('\n')
        .map((item, key) => {
        if (item.match(/__\d/)) {
            const index = parseInt(item.replace('__', ''), 10);
            const text = match[index].replace(replace, '');
            return React.createElement("b", { key: key }, text);
        }
        else if (item.match(LINK_REGEX)) {
            return textWithLinks(item);
        }
        return React.createElement("span", { key: key }, item);
    });
}
export function textWithLinks(text) {
    const match = (text && text.match(LINK_REGEX)) || [];
    const reducedMatch = match.reduce(convertToIndex, text);
    return (reducedMatch &&
        reducedMatch.split('\n').map((item, key) => {
            if (item.match(/__\d/)) {
                const link = match[parseInt(item.replace('__', ''), 10)];
                const href = link.replace(/\[.+?\]|\(|\)/g, '');
                const content = link.replace(/\(.+?\)|\[|\]/g, '');
                const stopPropagation = text.includes('#stopPropagation');
                return (React.createElement("span", { key: key },
                    React.createElement("a", { target: "_blank", className: "text-link", href: href, onClick: (e) => stopPropagation ? e.stopPropagation() : null }, content.replace('#stopPropagation', ''))));
            }
            else if (item.match(BOLD_REGEX)) {
                return textWithBold(item);
            }
            return React.createElement("span", { key: key }, item);
        }));
}
export function textSubstring(text, maxLength) {
    if (text.length > maxLength) {
        return `${text.substring(0, maxLength)}...`;
    }
    return text;
}
